<p-dialog [header]="popupHeader" [(visible)]="displayUpdateRecordDialog" [style]="{ width: '60vw' }"
    (onHide)="closeUpdateRecord()" [closable]="false" [modal]="true" [responsive]="true">

    <form class="card" [formGroup]="updateRecordForm" novalidate>
        <div class="p-grid">
            <div class="p-col-12">
                <div class="p-grid">
                    <div class="p-col-12 p-md-3">
                        <label>Update Type <span class="required-field">*</span></label>
                    </div>
                    <div class="p-col-12 p-md-9 p-d-flex">
                        <div *ngFor="let c of updateRecordType" class="p-mr-3">
                            <div class="p-field-checkbox p-mb-0">
                                <p-radioButton [inputId]="c.id" name="offerType" [value]="c.id"
                                    formControlName="offerType" [disabled]="viewOnly || selectedActionUpdateRecord?.id"></p-radioButton>
                                <label [for]="c.id">{{c.name}}</label>
                            </div>
                        </div>
                        <div *ngIf="detailsFormErrors?.offerType" class="p-invalid">
                            <small>{{ detailsFormErrors?.offerType }}</small>
                        </div>
                    </div>
                </div>
            </div>

            <div class="p-col-12" *ngIf="[updateRecordTypeEnum.FreeProduct].includes(updateRecordForm.getRawValue().offerType)">
                <div class="p-grid">
                    <div class="p-col-12">
                        <p-table [value]="selectedOfferOnProducts" responsiveLayout="scroll" styleClass="p-datatable-gridlines p-datatable-striped">
                            <ng-template pTemplate="caption">
                                <div class="p-d-flex p-jc-between">
                                    <h6 class="p-mb-0">Ordered Product</h6>
                                    <span class="btnBars" *ngIf="!viewOnly" (click)="addEditOfferOnProduct()">
                                        <i class="pi pi-plus"></i>
                                    </span>
                                </div>
                            </ng-template>
                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="width: 200px">Item No.</th>
                                    <th style="width: 250px">Desc.</th>
                                    <th style="width: 150px">Ordered Qty</th>
                                    <th style="width: 150px">UOM</th>
                                    <th style="text-align: right">Rate</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-product>
                                <tr>
                                    <td style="width: 200px">{{product.itemNo}}</td>
                                    <td style="width: 250px">{{product.description}}</td>
                                    <td pEditableColumn style="width: 150px">
                                        <p-cellEditor>
                                            <ng-template pTemplate="input">
                                                <p-inputNumber placeholder="Ordered Qty" step="0" formControlName="minOrderQty" [min]="0" mode="decimal"
                                                    (keypress)="isNumberKey($event)"
                                                    [disabled]="viewOnly" [minFractionDigits]="getDecimalPlacesCached(product.productUOM, updateRecordForm.value?.offerOnProductUOMId)"
                                                    [maxFractionDigits]="getDecimalPlacesCached(product.productUOM, updateRecordForm.value?.offerOnProductUOMId)"></p-inputNumber>
                                            </ng-template>
                                            <ng-template pTemplate="output"> {{ updateRecordForm.getRawValue().minOrderQty | customNumberFormat : getDecimalPlacesCached(product.productUOM, updateRecordForm.value?.offerOnProductUOMId)}} </ng-template>
                                        </p-cellEditor>
                                    </td>
                                    <td style="width: 150px">
                                        <p-dropdown
                                            [options]="product.productUOM"
                                            formControlName="offerOnProductUOMId"
                                            optionLabel="uomName"
                                            optionValue="unitOfMeasureId" appendTo="body"
                                            [autoDisplayFirst]="false"
                                            placeholder="Select UOM"
                                            class="noBorderDD" [dropdownIcon]="dropdownIcon"
                                            [disabled]="viewOnly">
                                        </p-dropdown>
                                    </td>
                                    <td style="text-align: right">{{(product?.sellPrice||0) | number: "1.2-2" | currencySymbol }}</td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td colspan="5" class="p-text-center">Select Order Product</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>

                    <div class="p-col-12">
                        <p-table [value]="selectedOfferedProducts" responsiveLayout="scroll" styleClass="p-datatable-gridlines p-datatable-striped">
                            <ng-template pTemplate="caption">
                                <div class="p-d-flex p-jc-between">
                                    <h6 class="p-mb-0">Offered Product</h6>
                                    <span class="btnBars" *ngIf="!viewOnly" (click)="addEditOfferedProduct()">
                                        <i class="pi pi-plus"></i>
                                    </span>
                                </div>
                            </ng-template>
                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="width: 200px">Item No.</th>
                                    <th style="width: 250px">Desc.</th>
                                    <th style="width: 150px">Offered Qty</th>
                                    <th style="width: 150px">UOM</th>
                                    <th style="text-align: right">Rate</th>
                                    <th style="width: 200px;">Discount</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-product>
                                <tr>
                                    <td style="width: 200px">{{product.itemNo}}</td>
                                    <td style="width: 250px">{{product.description}}</td>
                                    <td pEditableColumn style="width: 150px">
                                        <p-cellEditor>
                                            <ng-template pTemplate="input">
                                                <p-inputNumber placeholder="Offered Qty" step="0" formControlName="offeredQty" [min]="0"
                                                    mode="decimal"
                                                    (keypress)="isNumberKey($event)"
                                                    [disabled]="viewOnly"
                                                    [minFractionDigits]="getDecimalPlacesCached(product.productUOM, updateRecordForm.value?.offeredProductUOMId)" [maxFractionDigits]="getDecimalPlacesCached(product.productUOM, updateRecordForm.value?.offeredProductUOMId)" ></p-inputNumber>
                                            </ng-template>
                                            <ng-template pTemplate="output"> {{ updateRecordForm.getRawValue().offeredQty |customNumberFormat : getDecimalPlacesCached(product.productUOM, updateRecordForm.value?.offeredProductUOMId) }} </ng-template>
                                        </p-cellEditor>
                                    </td>
                                    <td style="width: 150px">
                                        <p-dropdown
                                            [options]="product.productUOM"
                                            formControlName="offeredProductUOMId"
                                            optionLabel="uomName"
                                            optionValue="unitOfMeasureId" appendTo="body"
                                            [autoDisplayFirst]="false"
                                            placeholder="Select UOM"
                                            class="noBorderDD" [dropdownIcon]="dropdownIcon"
                                            [disabled]="viewOnly">
                                        </p-dropdown>
                                    </td>
                                    <td style="text-align: right">{{(product?.sellPrice||0) | number: "1.2-2" | currencySymbol }}</td>
                                    <td pEditableColumn class="action" style="width: 200px;">
                                        <p-cellEditor>
                                            <ng-template pTemplate="input">
                                                <div class="p-d-flex discount-wrapper">
                                                    <p-dropdown
                                                        formControlName="offerDiscountTypeId"
                                                        class="small"
                                                        [options]="offerDiscountOptions"
                                                        optionLabel="description"
                                                        optionValue="id"
                                                        appendTo="body"
                                                        [dropdownIcon]="dropdownIcon"
                                                        [disabled]="viewOnly">
                                                    </p-dropdown>
                                                    <p-inputNumber [placeholder]="'Discount Value'" formControlName="offerDiscountAmount" class="noBorder fix-discount-width" [min]="0" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" [disabled]="viewOnly"></p-inputNumber>
                                                </div>
                                            </ng-template>
                                            <ng-template pTemplate="output">
                                                <span *ngIf="!updateRecordForm.getRawValue().offerDiscountAmount">{{viewOnly ? 'Free Product' : 'Apply Discount'}}</span>
                                                <span *ngIf="updateRecordForm.getRawValue().offerDiscountAmount>0">{{ updateRecordForm.getRawValue().offerDiscountAmount||0 }}{{ offereDiscountTypeDes }}</span>
                                            </ng-template>
                                        </p-cellEditor>
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td colspan="6" class="p-text-center">Select Offered Product</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
            </div>

            <div class="p-col-12" *ngIf="[updateRecordTypeEnum.DiscountAmount].includes(updateRecordForm.getRawValue().offerType)">
                <div class="p-grid">
                    <div class="p-col-12 p-md-3">
                        <label>Additonal Discount <span style="color: red;">*</span></label>
                    </div>
                    <div class="p-grid p-col-12 p-md-9">
                        <div class="p-d-flex p-pl-2">
                            <p-dropdown
                                class="p-mr-2"
                                (onChange)="selectAdditionalDiscount($event,configDiscountsList)"
                                formControlName="discountId"
                                [options]="configDiscountsList"
                                [autoDisplayFirst]="false"
                                optionLabel="description"
                                optionValue="id"
                                placeholder="Select Discount"
                                appendTo="body"
                                [dropdownIcon]="dropdownIcon"
                                [disabled]="viewOnly">
                            </p-dropdown>
                            <p-dropdown
                                formControlName="discountTypeId"
                                [options]="discountOptions"
                                [autoDisplayFirst]="false"
                                optionLabel="description"
                                optionValue="id"
                                placeholder="Discount Type"
                                appendTo="body"
                                [dropdownIcon]="dropdownIcon"
                                [disabled]="viewOnly">
                            </p-dropdown>
                            <p-inputNumber *ngIf="!updateRecordForm.getRawValue()?.expressionValue" [placeholder]="'Discount Value'" formControlName="discountAmount" [min]="0" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" [disabled]="viewOnly" class="discount-value-field"></p-inputNumber>
                            <span  *ngIf="[salesOrderModuleId, invoiceOrderModuleId, estimateOrderModuleId].includes(selectedModule?.objectId) && isAmountType" class="text-input-prefix with-edit-icon p-input-icon-right">
                                <i class="p-d-flex p-ai-center">
                                <i *ngIf="!updateRecordForm.getRawValue()?.expressionValue" (click)="openExpressionAdd()" class="pi pi-plus cursor-pointer" pTooltip="Add Expression"></i>
                                <i *ngIf="updateRecordForm.getRawValue()?.expressionValue"  (click)="openExpressionAdd()" class="pi pi-pencil cursor-pointer" pTooltip="Edit Expression"></i>
                                <i *ngIf="updateRecordForm.getRawValue()?.expressionValue"  (click)="removeExpression()" class="pi pi-trash cursor-pointer p-ml-2" pTooltip="Remove Expression"></i>
                                </i>
                                <input *ngIf="updateRecordForm.getRawValue()?.expressionValue" pInputText type="text" formControlName="expressionValue" placeholder="Enter New Value" [readOnly]="true" 
                                pTooltip="{{ updateRecordForm.getRawValue()?.expressionValue }}" 
                                tooltipPosition="top"/>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="p-col-12" *ngIf="[updateRecordTypeEnum.AdditionalHandlingCharge].includes(updateRecordForm.getRawValue().offerType)">
                <div class="p-grid">
                    <div class="p-col-12 p-md-3">
                        <label>Additonal Handling Fees <span style="color: red;">*</span></label>
                    </div>
                    <div class="p-grid p-col-12 p-md-9">
                        <div class="p-d-flex p-pl-2">
                            <p-dropdown
                                class="p-mr-2"
                                (onChange)="selectAdditionalDiscount($event,configHandlingFees)"
                                formControlName="discountId"
                                [options]="configHandlingFees"
                                [autoDisplayFirst]="false"
                                optionLabel="description"
                                optionValue="id"
                                placeholder="Select Handling Fee"
                                appendTo="body"
                                [dropdownIcon]="dropdownIcon"
                                [disabled]="viewOnly">
                            </p-dropdown>
                            <p-dropdown
                                formControlName="discountTypeId"
                                [options]="discountOptions"
                                [autoDisplayFirst]="false"
                                optionLabel="description"
                                optionValue="id"
                                placeholder="Type"
                                appendTo="body"
                                [dropdownIcon]="dropdownIcon"
                                [disabled]="viewOnly">
                            </p-dropdown>
                            <p-inputNumber *ngIf="!updateRecordForm.getRawValue()?.expressionValue" [placeholder]="'Value'" formControlName="discountAmount" [min]="0" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" [disabled]="viewOnly" class="discount-value-field"></p-inputNumber>
                             
                            <span  *ngIf="[salesOrderModuleId,invoiceOrderModuleId,estimateOrderModuleId].includes(selectedModule?.objectId) && isAmountType" class="text-input-prefix with-edit-icon p-input-icon-right">
                                <i class="p-d-flex p-ai-center">
                                <i *ngIf="!updateRecordForm.getRawValue()?.expressionValue" (click)="openExpressionAdd()" class="pi pi-plus cursor-pointer" pTooltip="Add Expression"></i>
                                <i *ngIf="updateRecordForm.getRawValue()?.expressionValue"  (click)="openExpressionAdd()" class="pi pi-pencil cursor-pointer" pTooltip="Edit Expression"></i>
                                <i *ngIf="updateRecordForm.getRawValue()?.expressionValue"  (click)="removeExpression()" class="pi pi-trash cursor-pointer p-ml-2" pTooltip="Remove Expression"></i>
                                </i>
                                <input *ngIf="updateRecordForm.getRawValue()?.expressionValue" pInputText type="text" formControlName="expressionValue" placeholder="Enter New Value" [readOnly]="true" 
                                pTooltip="{{ updateRecordForm.getRawValue()?.expressionValue }}" 
                                tooltipPosition="top"/>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="p-col-12" *ngIf="[updateRecordTypeEnum.TaxRateHandling].includes(updateRecordForm.getRawValue().offerType)">
                <div class="p-grid">
                    <div class="p-col-12 p-md-3">
                        <label>Tax Application Type <span style="color: red;">*</span></label>
                    </div>
                    <div class="p-grid p-col-12 p-md-9">
                        <div class="p-d-flex p-pl-2">
                            <p-dropdown
                                class="p-mr-2"
                                (onChange)="setTaxExempted($event)"
                                formControlName="taxExempted"
                                [options]="taxExemptedOptions"
                                optionLabel="name"
                                optionValue="id"
                                placeholder="Select Tax"
                                appendTo="body"
                                [dropdownIcon]="dropdownIcon"
                                [disabled]="viewOnly || selectedActionUpdateRecord">
                            </p-dropdown>
                            <p-dropdown *ngIf="updateRecordForm.getRawValue().taxExempted==1"
                                formControlName="taxRateId"
                                [options]="taxList"
                                [group]="true"
                                [filter]="true"
                                [autoDisplayFirst]="false"
                                optionValue="id"
                                placeholder="Select Tax"
                                appendTo="body"
                                [dropdownIcon]="dropdownIcon"
                                [disabled]="viewOnly || selectedActionUpdateRecord">
                            </p-dropdown>
                        </div>
                    </div>
                </div>
            </div>

            <div class="p-col-12" *ngIf="[updateRecordTypeEnum.TaxRateHandling].includes(updateRecordForm.getRawValue().offerType) && updateRecordForm.getRawValue().taxExempted==2">
                <div class="p-grid">
                    <div class="p-col-12" formArrayName="taxExemptedProducts">
                        <p-table [value]="getAddedTaxProducts(updateRecordForm)" responsiveLayout="scroll" styleClass="p-datatable-gridlines p-datatable-striped">
                            <ng-template pTemplate="caption">
                                <div class="p-d-flex p-jc-between">
                                    <h6 class="p-mb-0">Ordered Product</h6>
                                    <span class="btnBars" *ngIf="!viewOnly" (click)="addEditOfferOnProduct('multiple')">
                                        <i class="pi pi-plus"></i>
                                    </span>
                                </div>
                            </ng-template>
                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="width: 200px">Item No.</th>
                                    <th style="width: 250px">Desc.</th>
                                    <th style="width: 150px">UOM</th>
                                    <th style="width: 150px">Tax</th>
                                    <th style="text-align: right">Rate</th>
                                    <th *ngIf="!viewOnly" style="width: 4rem;text-align: right"></th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-productControl let-index="rowIndex">
                                <tr [formGroupName]="index">
                                    <td style="width: 200px">{{productControl.value.offerOnProduct.itemNo}}</td>
                                    <td style="width: 250px">{{productControl.value.offerOnProduct.description}}</td>
                                    <td style="width: 150px">
                                        <p-dropdown
                                            [options]="productControl.value.offerOnProduct.productUOM"
                                            formControlName="offerOnProductUOMId"
                                            optionLabel="uomName"
                                            optionValue="unitOfMeasureId" appendTo="body"
                                            [autoDisplayFirst]="false"
                                            placeholder="Select UOM"
                                            class="noBorderDD" [dropdownIcon]="dropdownIcon"
                                            [disabled]="viewOnly">
                                        </p-dropdown>
                                    </td>
                                    <td style="width: 150px">
                                        <p-dropdown
                                            [options]="taxList"
                                            [group]="true"
                                            [filter]="true"
                                            formControlName="taxRateId"
                                            optionValue="id" appendTo="body"
                                            [autoDisplayFirst]="false"
                                            placeholder="Select Tax"
                                            class="noBorderDD" [dropdownIcon]="dropdownIcon"
                                            [disabled]="viewOnly">
                                        </p-dropdown>
                                    </td>
                                    <td style="text-align: right">{{(productControl.value.offerOnProduct?.sellPrice||0) | number: "1.2-2" | currencySymbol }}</td>
                                    <td *ngIf="!viewOnly" style="width: 4rem;text-align: right">
                                        <span class="p-p-2 p-mr-2" style="cursor: pointer" pTooltip="Remove" tooltipPosition="top" (click)="removeTaxProduct(index)">
                                            <i class="pi pi-trash"></i>
                                        </span>
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td colspan="7" class="p-text-center">Select Order Product</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
            </div>

            <div class="p-col-12" *ngIf="[updateRecordTypeEnum.QtyDiscount,updateRecordTypeEnum.QtyHandlingCharge].includes(updateRecordForm.getRawValue().offerType)">
                <div class="p-grid">
                    <div class="p-col-12">
                        <p-table [value]="selectedOfferOnProducts" responsiveLayout="scroll" styleClass="p-datatable-gridlines p-datatable-striped">
                            <ng-template pTemplate="caption">
                                <div class="p-d-flex p-jc-between">
                                    <h6 class="p-mb-0">Ordered Product</h6>
                                    <span class="btnBars" *ngIf="!viewOnly" (click)="addEditOfferOnProduct()">
                                        <i class="pi pi-plus"></i>
                                    </span>
                                </div>
                            </ng-template>
                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="width: 200px">Item No.</th>
                                    <th style="width: 250px">Desc.</th>
                                    <th style="width: 150px">Ordered Qty</th>
                                    <th style="width: 150px">UOM</th>
                                    <th style="text-align: right">Rate</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-product>
                                <tr>
                                    <td style="width: 200px">{{product.itemNo}}</td>
                                    <td style="width: 250px">{{product.description}}</td>
                                    <td pEditableColumn style="width: 150px">
                                        <p-cellEditor>
                                            <ng-template pTemplate="input">
                                                <p-inputNumber placeholder="Ordered Qty" formControlName="minOrderQty"
                                                    (keypress)="isNumberKey($event)"
                                                    [disabled]="viewOnly"  step="0" [min]="0" mode="decimal" [minFractionDigits]="getDecimalPlacesCached(product.productUOM, updateRecordForm.value?.offerOnProductUOMId)"
                                                    [maxFractionDigits]="getDecimalPlacesCached(product.productUOM, updateRecordForm.value?.offerOnProductUOMId)">
                                                </p-inputNumber>
                                            </ng-template>
                                            <ng-template pTemplate="output"> {{ updateRecordForm.getRawValue().minOrderQty | customNumberFormat : getDecimalPlacesCached(product.productUOM, updateRecordForm.value?.offerOnProductUOMId) }} </ng-template>
                                        </p-cellEditor>
                                    </td>
                                    <td style="width: 150px">
                                        <p-dropdown
                                            [options]="product.productUOM"
                                            formControlName="offerOnProductUOMId"
                                            optionLabel="uomName"
                                            optionValue="unitOfMeasureId" appendTo="body"
                                            [autoDisplayFirst]="false"
                                            placeholder="Select UOM"
                                            class="noBorderDD" [dropdownIcon]="dropdownIcon"
                                            [disabled]="viewOnly">
                                        </p-dropdown>
                                    </td>
                                    <td style="text-align: right">{{(product?.sellPrice||0) | number: "1.2-2" | currencySymbol }}</td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td colspan="7" class="p-text-center">Select Order Product</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                    <div class="p-col-12" formArrayName="workflowUpdateRecordQtyDiscounts">
                        <p-table [value]="getAddedQtyDiscounts(updateRecordForm)" responsiveLayout="scroll" styleClass="p-datatable-gridlines p-datatable-striped" dataKey="id">
                            <ng-template pTemplate="caption">
                                <div class="p-d-flex p-jc-between">
                                    <h6 *ngIf="[updateRecordTypeEnum.QtyDiscount].includes(updateRecordForm.getRawValue().offerType)" class="p-mb-0">Qty Discount</h6>
                                    <h6 *ngIf="[updateRecordTypeEnum.QtyHandlingCharge].includes(updateRecordForm.getRawValue().offerType)" class="p-mb-0">Qty Handling Fees</h6>
                                    <span class="btnBars" (click)="addQtyDiscount()" *ngIf="(selectedOfferOnProducts.length > 0 && !viewOnly)">
                                        <i class="pi pi-plus"></i>
                                    </span>
                                </div>
                            </ng-template>
                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="width: 200px">Operator</th>
                                    <th>Order Qty</th>
                                    <th style="text-align: right">Rate</th>
                                    <th *ngIf="[updateRecordTypeEnum.QtyDiscount].includes(updateRecordForm.getRawValue().offerType)" style="width: 200px;">Discount</th>
                                    <th *ngIf="[updateRecordTypeEnum.QtyHandlingCharge].includes(updateRecordForm.getRawValue().offerType)" style="width: 200px;">Handling Fees</th>
                                    <th style="width: 60px;"></th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-discountControl let-index="rowIndex">
                                <tr [formGroupName]="index">
                                    <td style="width: 200px">
                                        <p-dropdown
                                            [options]="(qtyOperators | workflowQtyDiscountOperators:discountControl.value.operator:updateRecordForm.getRawValue().workflowUpdateRecordQtyDiscounts)"
                                            formControlName="operator"
                                            optionLabel="name"
                                            optionValue="id" appendTo="body"
                                            [autoDisplayFirst]="false"
                                            placeholder="Select Operator"
                                            class="noBorderDD" [dropdownIcon]="dropdownIcon"
                                            [disabled]="viewOnly">
                                        </p-dropdown>
                                    </td>
                                    <td pEditableColumn>
                                        <p-cellEditor>
                                            <ng-template pTemplate="input">
                                                <div class="p-d-flex p-ai-center">
                                                    <p-inputNumber placeholder="Ordered Qty" formControlName="fromOrderedQty" step="0" [min]="0" mode="decimal"
                                                        (keypress)="isNumberKey($event)" [disabled]="viewOnly"
                                                        [minFractionDigits]="getDecimalPlacesCached(selectedOfferOnProducts?.[0]?.productUOM, updateRecordForm.value?.offerOnProductUOMId)"
                                                        [maxFractionDigits]="getDecimalPlacesCached(selectedOfferOnProducts?.[0]?.productUOM, updateRecordForm.value?.offerOnProductUOMId)">
                                                    </p-inputNumber>

                                                    <ng-container *ngIf="[workflowOfferedQtyOperators.Between,workflowOfferedQtyOperators.NotBetween].includes(discountControl.value.operator)">
                                                        <span class="p-p-2 p-text-center" style="min-width: 50px;">To</span>

                                                        <p-inputNumber placeholder="Ordered Qty" formControlName="toOrderedQty" step="0" [min]="0" mode="decimal"
                                                            (keypress)="isNumberKey($event)" [disabled]="viewOnly"
                                                            [minFractionDigits]="getDecimalPlacesCached(selectedOfferOnProducts?.[0]?.productUOM, updateRecordForm.value?.offerOnProductUOMId)"
                                                            [maxFractionDigits]="getDecimalPlacesCached(selectedOfferOnProducts?.[0]?.productUOM, updateRecordForm.value?.offerOnProductUOMId)">
                                                        </p-inputNumber>
                                                    </ng-container>
                                                </div>
                                            </ng-template>
                                            <ng-template pTemplate="output">
                                                {{ discountControl.value.fromOrderedQty | customNumberFormat : getDecimalPlacesCached(selectedOfferOnProducts?.[0]?.productUOM, updateRecordForm.value?.offerOnProductUOMId) }}
                                                <ng-container *ngIf="[workflowOfferedQtyOperators.Between,workflowOfferedQtyOperators.NotBetween].includes(discountControl.value.operator)">
                                                    <span class="p-p-2">To</span>
                                                    {{ discountControl.value.toOrderedQty | customNumberFormat : getDecimalPlacesCached(selectedOfferOnProducts?.[0]?.productUOM, updateRecordForm.value?.offerOnProductUOMId) }}
                                                </ng-container>
                                            </ng-template>
                                        </p-cellEditor>


                                    </td>
                                    <td style="text-align: right">
                                        {{(selectedOfferOnProducts[0]?.sellPrice||0) | number: "1.2-2" | currencySymbol }}
                                    </td>
                                    <td style="width: 200px;">
                                        <div class="p-d-flex discount-wrapper">
                                            <ng-container *ngIf="[updateRecordTypeEnum.QtyDiscount].includes(updateRecordForm.getRawValue().offerType)">
                                                <p-dropdown
                                                    (onChange)="changeQtyDiscountType($event,discountControl,true,configDiscountsList)"
                                                    placeholder="Discount"
                                                    formControlName="discountId"
                                                    class="small"
                                                    [options]="configDiscountsList"
                                                    [autoDisplayFirst]="false"
                                                    optionLabel="description"
                                                    optionValue="id"
                                                    appendTo="body"
                                                    [dropdownIcon]="dropdownIcon"
                                                    [disabled]="viewOnly">
                                                </p-dropdown>
                                            </ng-container>
                                            <ng-container *ngIf="[updateRecordTypeEnum.QtyHandlingCharge].includes(updateRecordForm.getRawValue().offerType)">
                                                <p-dropdown
                                                    (onChange)="changeQtyDiscountType($event,discountControl,true,configHandlingFees)"
                                                    placeholder="Handling Fees"
                                                    formControlName="discountId"
                                                    class="small"
                                                    [options]="configHandlingFees"
                                                    [autoDisplayFirst]="false"
                                                    optionLabel="description"
                                                    optionValue="id"
                                                    appendTo="body"
                                                    [dropdownIcon]="dropdownIcon"
                                                    [disabled]="viewOnly">
                                                </p-dropdown>
                                            </ng-container>

                                            <p-inputNumber [placeholder]="'Value'" formControlName="discountAmount" class="noBorder fix-discount-width" [min]="0" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" [disabled]="viewOnly"></p-inputNumber>
                                        </div>
                                    </td>
                                    <td class="action" style="width: 60px;">
                                        <span class="btnBars">
                                            <i class="pi pi-trash" (click)="removeQtyDiscount(index)"></i>
                                        </span>
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td colspan="6" class="p-text-center">Select Order Product</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
            </div>

        </div>
    </form>

    <p-footer>
        <button type="button" pButton (click)="closeUpdateRecord()" label="Cancel" class="p-button-secondary"></button>
        <button *ngIf="!viewOnly" type="submit" pButton (click)="saveUpdateRecord()" label="Save"></button>
    </p-footer>
</p-dialog>

<!--Product add common component -->
<app-product-selection-modal *ngIf="updateRecordForm" [displayProductSelectionModal]="displayProductSelectionModal"
    [selectionMode]="selectionMode" [moduleName]="'Bundle'"
    [headerText]="headerText" [selectedProductsList]="selectedProductsList"
    [isVisibleLocation]="true" [selectDefaultLocation]="true"
    [selectedLocationId]="selectedLocationId" [selectedAccountId]="0"
    (onCancelClicked)="onProductCancelClicked($event)" (onProductAddComplete)="onProductAddComplete($event)" (onLocationSelect)="onLocationSelect($event)">
</app-product-selection-modal>

<app-add-fields-expression-dialog
    *ngIf="displayAddExpression"
    [displayAddExpression]="displayAddExpression"
    [viewOnly]="viewOnly"
    [expressionText]="expressionText"
    [availableFieldsForExpression]="availableFieldsForExpression"
    (expressionSaved)="saveExpression($event)"
    (dialogClosed)="expressionDialogClose()">
</app-add-fields-expression-dialog>
